import {
  getSPDataWithParams,
  postSPDataWithoutParams,
} from './services'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'

const BASE = '/api/secure/cc/support/clinic-workforce'

/**
 * Fetch the flat clinic-location list (each item carries clinicBrandId / clinicBrandName), the same
 * source the clinics page uses, and group it into brands -> locations for the assignment UIs.
 */
export async function fetchClinicBrandsWithLocations() {
  const resp = await getSPDataWithParams(
    '/api/secure/cc/support/clinics-with-brands/list',
    {},
    undefined,
    undefined,
    true,
  )
  if (!(resp && isCommonResponseSuccessfulV2(resp))) {
    return []
  }
  const locations = getDataMapFromCommonResponse(resp)?.clinic || []
  const byBrand = new Map()
  locations.forEach((loc) => {
    const brandId = loc?.clinicBrandId
    if (!brandId) return
    if (!byBrand.has(brandId)) {
      byBrand.set(brandId, {
        id: brandId,
        title: loc?.clinicBrandName || 'Clinic brand',
        slug: loc?.clinicBrandSlug,
        locations: [],
      })
    }
    byBrand.get(brandId).locations.push({
      id: loc?.id,
      title: loc?.title || 'Clinic location',
      address: loc?.address,
      clinicBrandId: brandId,
    })
  })
  return [...byBrand.values()]
}

/** Returns { brandIds: string[], locationIds: string[] } the practitioner currently belongs to. */
export async function fetchPractitionerClinicAssignments(practitionerId) {
  const resp = await getSPDataWithParams(`${BASE}/practitioner/assignments`, { practitionerId })
  if (!(resp?.status === 200 && isCommonResponseSuccessfulV2(resp))) {
    return { brandIds: [], locationIds: [] }
  }
  const data = getDataMapFromCommonResponse(resp) || {}
  return {
    brandIds: Array.isArray(data.brandIds) ? data.brandIds : [],
    locationIds: Array.isArray(data.locationIds) ? data.locationIds : [],
  }
}

export function assignPractitionerToLocation(payload) {
  return postSPDataWithoutParams(`${BASE}/location/assign`, payload)
}

export function unassignPractitionerFromLocation(payload) {
  return postSPDataWithoutParams(`${BASE}/location/unassign`, payload)
}

export function assignPractitionerToBrand(payload) {
  return postSPDataWithoutParams(`${BASE}/brand/assign`, payload)
}

export function unassignPractitionerFromBrand(payload) {
  return postSPDataWithoutParams(`${BASE}/brand/unassign`, payload)
}
